// ------SAMPLE CALLS------

import { getToken, getUser } from "../../Utilities/Common";
import {
  postAPICallwithFile,
  postAPICall,
  getWithParamsAPICall,
} from "../axiosMethodCall";

export const getPrescriptionTemplates = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      search: data?.search || "",
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "prescriptions/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const getPrescriptionCategories = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "prescription_categories/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createPrescription = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("prescription_name", data?.prescription_name || "");
    formData.append("prescription_count", data.prescription_details.length);
    formData.append("description", data?.description || "");
    formData.append("category_name", data?.category_name?.label || "");

    data.prescription_details.forEach((medicine) => {
      formData.append("generic[]", medicine.generic);
      formData.append("brand[]", medicine.brand);
      formData.append("dosage[]", medicine.dosage);
      formData.append("preparation[]", medicine.preparation);
      formData.append("quantity[]", medicine.quantity);
      formData.append("duration[]", medicine.duration);
      formData.append("instruction[]", medicine.instruction);
      // formData.append("form[]", medicine.form);
      // formData.append("frequency[]", medicine.frequency);
      // formData.append("timing[]", medicine.timing);
    });

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "prescriptions/create",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updatePrescription = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("prescription_id", data?.prescription_id);
    formData.append("prescription_name", data?.prescription_name);
    formData.append("prescription_count", data.prescription_details.length);
    formData.append("description", data?.description || "");
    formData.append("category_id", data.category_name.value || "");
    formData.append("category_name", data.category_name.label || "");

    data.prescription_details.forEach((medicine) => {
      formData.append("generic[]", medicine.generic);
      formData.append("brand[]", medicine.brand);
      formData.append("dosage[]", medicine.dosage);
      formData.append("preparation[]", medicine.preparation);
      formData.append("quantity[]", medicine.quantity);
      formData.append("duration[]", medicine.duration);
      formData.append("instruction[]", medicine.instruction);
      // formData.append("form[]", medicine.form);
      // formData.append("frequency[]", medicine.frequency);
      // formData.append("timing[]", medicine.timing);
    });

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "prescriptions/update",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deletePrescriptionTemplate = async (prescriptionId) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      prescription_id: prescriptionId,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "prescriptions/delete",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createTherapuetic = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "gdm_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        oag: data.oag,
        fasting: data.fasting,
        glucose_load_1h: data.glucose_load_1h,
        glucose_load_2h: data.glucose_load_2h,
        insulin_use: data.insulin_use,
        handout_link: data.handout_link,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
